import React, { useReducer } from "react";
import egumaReact from "egumaReact"; // added in externals in webpack
import { SecondaryButton } from "../Button";
import Polyglot from "node-polyglot";
import client from "../../Lib/client";
const polyglot = new Polyglot({ phrases: egumaReact.translations });

const actions = {
  SET_PROMOCODE: "setPromocode",
  RESET_PROMOCODE: "resetPromocode",
  SET_ERROR: "setError",
  RESET_ERROR: "resetError"
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_PROMOCODE:
      return { ...state, promoCode: action.promoCode };
    case actions.RESET_PROMOCODE:
      return { ...state, promoCode: "" };
    case actions.SET_ERROR:
      return { ...state, error: action.error };
    case actions.RESET_ERROR:
      return { ...state, error: false };
    default:
      throw new Error("Action not implemented");
  }
};

const PromocodeForm = ({ callback = () => {}, selectedDate = null }) => {
  const [state, dispatch] = useReducer(reducer, {
    promoCode: "",
    error: false
  });

  const { error, promoCode } = state;

  const addPromocode = async () => {
    try {
      console.log(selectedDate);

      // Bergbahnen Meiringen-Hasliberg
      // 1-Tagespass Ski Winter 2023/2024
      // The promocode is only valid for some days.
      if (
        egumaReact.eventId === "5dd287746588552984d8e8eb" &&
        selectedDate !== null &&
        selectedDate >= Date.parse("2024-01-27") &&
        selectedDate < Date.parse("2024-02-26")
      ) {
        alert("Der Promo-Code ist für das gewählte Datum nicht gültig.");
        return;
      }

      const payload = {
        eventId: egumaReact.eventId,
        code: promoCode
      };

      const data = await client(
        `/api/${egumaReact.mandantId}/${egumaReact.lang}/addpromocode`,
        { body: payload }
      );

      if (!data.success) {
        dispatch({
          type: actions.SET_ERROR,
          error: data.message || polyglot.t(data.messageLabel)
        });
        return;
      }

      dispatch({ type: actions.RESET_PROMOCODE });

      callback(data.newTickets);
    } catch (e) {
      console.log(e);
      dispatch({
        type: actions.SET_ERROR,
        error: polyglot.t("Promocode.Message.ErrorAddingPromocode")
      });
    }
  };

  return (
    <div style={{ marginTop: 70 }}>
      <div className="row">
        <div
          id="ticketing-add-promocode-label"
          className="col-md-12"
          style={{ marginBottom: 16 }}
        >
          {polyglot.t("Promocode.Message.DoYouHaveAPromocode")}
        </div>
      </div>
      <div className="row">
        <div className="col-md-6" style={{ marginBottom: 16 }}>
          <input
            type="text"
            id="promocode"
            name="code"
            placeholder={polyglot.t("Common.Code")}
            value={promoCode}
            onChange={e =>
              dispatch({
                type: actions.SET_PROMOCODE,
                promoCode: e.target.value
              })
            }
            autoComplete="off"
          />
        </div>
        <div className="col-md-6" style={{ marginBottom: 16 }}>
          <SecondaryButton fullWidth onClick={addPromocode}>
            {polyglot.t("Shop.Action.ApplyPromocode")}
          </SecondaryButton>
        </div>
      </div>
      {error && (
        <div
          id="promocode-msg"
          className="alert alert-warning"
          style={{ marginBottom: 0 }}
          role="alert"
          dangerouslySetInnerHTML={{ __html: error }}
        ></div>
      )}
    </div>
  );
};

export default PromocodeForm;
